import { Actions } from '@src/constants/Constants';
import IS_USER_LOADING = Actions.IS_USER_LOADING;
import IS_USER_AUTHORIZED = Actions.IS_USER_AUTHORIZED;
import UPDATE_USER_PHONE = Actions.UPDATE_USER_PHONE;
import SHOW_PROVIDE_PIN = Actions.SHOW_PROVIDE_PIN;

export interface IUserState {
    isAuthorized: boolean;
    isLoading: boolean;
    username: string;
    phoneNumber: string;
    showProvidePin: string;
}

const initialState: IUserState = {
    isAuthorized: false,
    isLoading: false,
    username: '',
    phoneNumber: '',
    showProvidePin: null,
};

export default function userState(
    state: IUserState = initialState,
    action: any,
): IUserState {
    switch (action.type) {
        case IS_USER_LOADING:
            return { ...state, isLoading: action.payload };

        case UPDATE_USER_PHONE:
            return { ...state, phoneNumber: action.payload };


        case SHOW_PROVIDE_PIN:
            return { ...state, showProvidePin: action.payload };

        case IS_USER_AUTHORIZED:
            const isAuthorized: boolean = action.payload.isAuthorized;
            const username: string = action.payload.username;
            return { ...state, isAuthorized, username };
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/reducers/UserReducer.ts